// src/components/common/LoadingSpinner.tsx
// 統一的 Loading 旋轉指示器，取代各頁面的內聯實作

import React from 'react';

interface LoadingSpinnerProps {
  /**
   * spinner 圓圈大小
   * - 'sm': h-8 w-8（內容區塊，如 Tasks list）
   * - 'md': h-10 w-10（Modal 或半頁區塊，如 TaskDetail）
   * - 'lg': h-12 w-12（整頁區塊，如 Calendar、Goals）
   * @default 'md'
   */
  size?: 'sm' | 'md' | 'lg';
  /** 顯示在 spinner 下方的說明文字（可選） */
  text?: string;
  /** 外層容器的附加 className（用於控制容器高度） */
  className?: string;
}

const SIZE_CLASS: Record<NonNullable<LoadingSpinnerProps['size']>, string> = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  text,
  className = '',
}) => (
  <div className={`flex items-center justify-center ${className}`}>
    <div className="flex flex-col items-center">
      <div
        role="status"
        aria-label={text ?? 'Loading'}
        className={`animate-spin rounded-full border-b-2 border-sky-500 ${SIZE_CLASS[size]}`}
      />
      {text && (
        <span className="mt-2 text-sm text-gray-500">{text}</span>
      )}
    </div>
  </div>
);

export default LoadingSpinner;
